import { isNumber } from "@thi.ng/checks/is-number";
export function mapVectors(fn, out, a, b, c) {
    const num = a.length;
    !out && (out = new Array(num));
    c !== undefined
        ? isNumber(c)
            ? mapVVN(fn, out, a, b, c)
            : mapVVV(fn, out, a, b, c)
        : isNumber(b)
            ? mapVN(fn, out, a, b)
            : mapVV(fn, out, a, b);
    return out;
}
const mapVN = (fn, out, a, b) => {
    for (let i = 0, num = a.length; i < num; i++) {
        out[i] = fn(out[i] || [], a[i], b);
    }
};
const mapVV = (fn, out, a, b) => {
    for (let i = 0, num = a.length; i < num; i++) {
        out[i] = fn(out[i] || [], a[i], b[i]);
    }
};
const mapVVN = (fn, out, a, b, c) => {
    for (let i = 0, num = a.length; i < num; i++) {
        out[i] = fn(out[i] || [], a[i], b[i], c);
    }
};
const mapVVV = (fn, out, a, b, c) => {
    for (let i = 0, num = a.length; i < num; i++) {
        out[i] = fn(out[i] || [], a[i], b[i], c[i]);
    }
};
